import React from 'react'

const SVG = ({
  style = {},
  fill = '#666666',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 20 20'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g>
      <path
        fill={fill}
        d='M9,17.8H3c-0.5,0-0.9-0.4-0.9-0.9V3.1c0-0.5,0.4-0.9,0.9-0.9h6c0.6,0,1.1-0.5,1.1-1.1S9.7,0,9,0H3
		C1.4,0,0,1.4,0,3.1v13.8C0,18.6,1.4,20,3.1,20h6c0.6,0,1.1-0.5,1.1-1.1S9.7,17.8,9,17.8z'
      />
      <path
        fill={fill}
        d='M22,9.9c0-0.1,0-0.5-0.3-0.7l0,0l-4.9-4.9c-0.4-0.4-1.1-0.4-1.6,0c-0.4,0.4-0.4,1.1,0,1.6l3,3H7
		c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h11.2l-3,3c-0.4,0.4-0.4,1.1,0,1.6c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3l4.9-4.9l0,0
		C22,10.5,22,10.1,22,9.9z'
      />
    </g>
  </svg>
)

export default SVG
